import { Injectable } from '@angular/core';
import { PhoneStatus } from '../../models/generated/ziroModels';
import { PollingAbstractService } from '../abstract/polling.abstract.service';

@Injectable({
  providedIn: 'root',
})
export class DeviceRegistrationStatusPollingService extends PollingAbstractService<PhoneStatus> {
  baseUrl = '';

  protected _pollingTimeInMilliseconds = 15000;

  setBaseUrl(name: string, cucmServerId: string | number): void {
    this.baseUrl = `/services/cisco/macs/cucm-servers/${encodeURIComponent(
      String(cucmServerId),
    )}/phones/${encodeURIComponent(name)}/status`;
  }
}
